import React, { useRef, memo, useEffect } from "react";
import { useIntersectionObserver } from "./useIntersectionObserver";
import { getWebHeaders } from "../helpers";
// the image content size for md and lg are the same like BE response image size,
// the values can be changed on client side based on future project
const imageSizes = {
    sm: {
        width: 36,
        height: 36
    },
    md: {
        width: 140,
        height: 187
    },
    lg: {
        width: 160,
        height: 160
    },
};
export const PlayerImage = memo((props) => {
    const { s3AssetsRoot, swooshBaseUrl } = props.productConfig;
    const defaultPlayerImage = `${s3AssetsRoot}/DefaultPlayerImage.svg`;
    const refRoot = useRef({});
    const { isVisible, domRegister, unRegisterDom } = useIntersectionObserver({});
    const { dkPlayerId, size, isPlayerImageDisabled, trackEvent, consumerVersion } = props;
    const imageContentSize = imageSizes[size];
    const [imageSrc, setImageSrc] = React.useState(defaultPlayerImage);
    useEffect(() => {
        if (isVisible && dkPlayerId && !isPlayerImageDisabled) {
            fetch(`${swooshBaseUrl}v1/players/${dkPlayerId}/image?size=${size}`, {
                method: "GET",
                mode: "cors",
                headers: getWebHeaders(consumerVersion, "player-image")
            }).then(res => {
                if (res.status >= 400) {
                    throw new Error(`${res.status} ${res.statusText}`);
                }
                if (res.ok && res.status === 200) {
                    return res.blob();
                }
                return undefined;
            }).then(data => {
                if (data) {
                    const src = URL.createObjectURL(data);
                    setImageSrc(src);
                }
            }).catch(error => {
                trackEvent("PLAYER_IMAGES_ERROR", {
                    message: error.message,
                    dkPlayerId,
                    consumerVersion,
                });
            }).finally(() => unRegisterDom(refRoot.current));
        }
    }, [isVisible, dkPlayerId, isPlayerImageDisabled, consumerVersion]);
    useEffect(() => {
        if (refRoot.current) {
            domRegister(refRoot.current);
        }
        return () => {
            unRegisterDom(refRoot.current);
        };
    }, [dkPlayerId, domRegister, unRegisterDom]);
    const revokeObjectURL = () => {
        var _a;
        if (((_a = refRoot.current) === null || _a === void 0 ? void 0 : _a.src) !== defaultPlayerImage) {
            URL.revokeObjectURL(imageSrc);
        }
    };
    return (React.createElement("img", { className: 'sportsbook-player-image', onLoad: revokeObjectURL, src: imageSrc, alt: "player image", width: imageContentSize.width, height: imageContentSize.height, ref: refRoot, "data-testid": 'sportsbook-player-image' }));
});
//# sourceMappingURL=PlayerImage.js.map